/**
 * Démonstration du déplacement d'un widget (drag & drop) pour le tutoriel.
 * La carte météo se déplace entre deux emplacements ; une zone verte (même visuel
 * que le placeholder de la grille) apparaît à la destination pour montrer où le
 * widget va se poser au lâcher du clic.
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WeatherWidget } from "../widgets/WeatherWidget";
import { WidgetPreviewContext } from "../widgets/WidgetShell";

export function MoveDemo({ running }: { running: boolean }) {
  const cls = running ? "is-running" : "";

  return (
    <>
      {/* Zones de destination (vert) — même visuel que le placeholder de la grille. */}
      <span className={`tutorial-drop-zone tutorial-drop-zone-a ${cls}`} />
      <span className={`tutorial-drop-zone tutorial-drop-zone-b ${cls}`} />

      {/* Widget météo déplacé. */}
      <div className={`tutorial-move-widget ${cls}`}>
        <WidgetPreviewContext.Provider value={true}>
          <WeatherWidget locationName="Lanester" />
        </WidgetPreviewContext.Provider>
      </div>

      {/* Curseur qui « tient » le widget pendant le déplacement. */}
      <div className={`tutorial-move-cursor ${cls}`} aria-hidden="true">
        <span className="tutorial-cursor-ring" />
        <FontAwesomeIcon
          icon="arrow-pointer"
          className="tutorial-cursor-icon text-default-text"
        />
      </div>
    </>
  );
}
